import PropTypes from 'prop-types';
import React from 'react';
import {Box, styled} from '@mui/material';
import {
  CustomLoadingOverlay,
  NoResultsOverlay,
  NoRowsOverlay,
} from './DataGridOverlays';
import {DataGridPro} from '@mui/x-data-grid-pro';
import {LicenseInfo} from '@mui/x-license-pro';
import {pageSizeOptions} from '@account/utils/query-params';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MATERIAL_UI_LICENSE);

const StyledGrid = styled(DataGridPro)(({theme}) => {
  const borderColor = theme.palette.grey[200];

  return {
    border: 'none',
    borderRadius: 0,
    background: theme.palette.background.paper,
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within':
      {
        outline: 'none',
      },
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: `1px solid ${borderColor}`,
    },
    '& .MuiDataGrid-cell': {
      borderBottom: `1px solid ${borderColor}`,
    },
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: theme.palette.primary.lighter,
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: `1px solid ${borderColor}`,
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'hidden',
    },
  };
});

const DataGrid = ({slots, ...props}) => (
  <Box display="flex" flex={1} overflow="hidden">
    <StyledGrid
      disableColumnFilter
      disableColumnMenu
      disableColumnReorder
      disableDensitySelector
      disableMultipleColumnsSorting
      disableMultipleSelection
      disableSelectionOnClick
      pageSizeOptions={pageSizeOptions}
      slots={{
        loadingOverlay: CustomLoadingOverlay,
        noResultsOverlay: NoResultsOverlay,
        noRowsOverlay: NoRowsOverlay,
        ...slots,
      }}
      sortingOrder={['asc', 'desc']}
      {...props}
    />
  </Box>
);

DataGrid.propTypes = {
  slots: PropTypes.object,
};

export default DataGrid;
